import { useConsole } from "contexts/Console"
import { useLocale } from "contexts/Locale"
import { Provider } from "contexts/User"
import useTopDomain from "hooks/useTopDomain"

const known2PartCodes = ["zh-hans", "zh-hant", "zh-tw", "zh-cn"]

export default function User({ children, reqcontext = {} }) {
  const console = useConsole()
  const topDomain = useTopDomain()
  const locale = useLocale()

  const naturalLanguages = global?.navigator?.languages ?? []
  const fromOverrideLanguages = global?.document?.documentElement?.getAttribute?.("data-languages")
  const userLanguages = fromOverrideLanguages ? new Set(fromOverrideLanguages.split(",")) : new Set([...naturalLanguages])

  for (const userLanguage of userLanguages) {
    if (known2PartCodes.includes(userLanguage.toLowerCase())) {
      continue
    }
    const [lang, country] = userLanguage.split("-")
    if (country) {
      userLanguages.add(lang)
    }
  }

  const ctx = {
    ...reqcontext,
    get languages() {
      return [...userLanguages]
    },
    get locale() {
      return ""
    },
    set locale(code) {
      const cookie = [
        `rlx-language=${code}`,
        // `domain=${topDomain}`, // don't inculde domain to match server-side behavior
        "path=/",
        "max-age=31536000", // 1 year
        "SameSite=Strict",
      ]
        .filter(Boolean)
        .join("; ")

      console.verbose("User:locale(%s) [%s]", code, cookie)
      document.cookie = cookie
    },
    get displayCurrencyBanner() {
      const countryBanner = reqcontext.countryCode !== reqcontext.realCountryCode && /* only on static versions! */ locale.current.codes.country
      const localeBanner =
        process.browser &&
        locale.current.codes.www !== locale.defaultLocale.codes.www /* en (int) never display the locale banner */ &&
        !ctx.languages.includes(locale.current.codes.ws)

      if (locale.defaultLocale.codes.www === "zh-hans") {
        // cn
        return false
      }
      return countryBanner ? "country" : localeBanner ? "locale" : false
    },
  }

  // const proxy = new Proxy(ctx, {
  //   get: (ctx, key) => {
  //     if (key === "countryCode") {
  //       return ctx.countryCode
  //     }

  //     if (key === "realCountryCode")
  //       return ctx.realCountryCode

  //     return ctx[key]
  //   }
  // })

  // Due to digitalDataLayer function being outside of the React component tree,
  // we need to set the locale in the global object for it to be accessible.
  if (process.browser) {
    global.__rlx ??= {}
    global.__rlx.countryCode = ctx.countryCode
    global.__rlx.realCountryCode = ctx.realCountryCode
  }

  console.ssr("User(%o)", ctx)
  return <Provider value={ctx}>{children}</Provider>
}
